<template>
  <v-container fluid>
    <v-row>
      <site-work-top-bar type="ESS" :site-info="siteInfo"></site-work-top-bar>
    </v-row>
    <v-row>
      <v-tabs
        fixed-tabs>
        <v-tab>운전현황</v-tab>
        <v-tab>배터리</v-tab>
        <v-tab>태양광</v-tab>
        <v-tab>ESS</v-tab>
        <v-tab>Rack</v-tab>
        <v-tab>이력정보</v-tab>
        <v-tab>트렌드</v-tab>
        <v-tab-item>
          <work-state :ess-data="essData"></work-state>
        </v-tab-item>
        <v-tab-item>
          <work-battery :ess-data="essData"></work-battery>
        </v-tab-item>
        <v-tab-item>
          <work-p-c-s :ess-data="essData"></work-p-c-s>
        </v-tab-item>
        <v-tab-item>
          <work-e-s-s :ess-data="essData"></work-e-s-s>
        </v-tab-item>
        <v-tab-item>
          <work-rack :ess-data="essData"></work-rack>
        </v-tab-item>
        <v-tab-item>
          <work-record :site_id="site_id" :ess-data="essData"></work-record>
        </v-tab-item>
        <v-tab-item>
          <work-trend :ess-data="essData"></work-trend>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store'
import localStore from '@/utils/localStore'
import { isMobile, getAgent, isTablet } from '@/utils/check'

import { getGeneral } from '@/api/ess/siteWork'
import { getSiteSearchList } from '@/api/greenCommon/site'
import { getSiteList, getSiteInfo } from '@/api/pcs/siteWork'
import { weatherGet, weatherPost } from '@/api/weather'
import SiteWorkTopBar from '@/components/monitoring/SiteWorkTopBar'
import WorkState from '@/views/pc/siteEss/WorkState'
import WorkBattery from '@/views/pc/siteEss/WorkBattery'
import WorkPCS from '@/views/pc/siteEss/WorkPCS'
import WorkESS from '@/views/pc/siteEss/WorkESS'
import WorkRack from '@/views/pc/siteEss/WorkRack'
import WorkRecord from '@/views/pc/siteEss/WorkRecord'
import WorkTrend from '@/views/pc/siteEss/WorkTrend'

let intervalHandler

export default {
  components: {
    SiteWorkTopBar,
    WorkState,
    WorkBattery,
    WorkPCS,
    WorkESS,
    WorkRack,
    WorkRecord,
    WorkTrend
  },
  data() {
    return {
      mobile_check: true,
      site_id: '',
      comp: 'WorkState',
      component_key: 1,
      searchArea: false,
      siteOn: false,
      regionOn: false,
      admin: false, // 관리자 여부
      devideType: 'PC', // PC,Mobile 같이 쓰는 페이지여서 구분 추가
      essData: { result: 'noData' },
      searchInfo: '', // 검색리스트
      searchSiteArea: [], // 검색리스트 확장
      regionTab: [
        { region: '경기도', tab: true },
        { region: '강원도', tab: false },
        { region: '충청남도', tab: false },
        { region: '충청북도', tab: false },
        { region: '경상남도', tab: false },
        { region: '경상북도', tab: false },
        { region: '전라남도', tab: false },
        { region: '전라북도', tab: false },
        { region: '제주도', tab: false },
        { region: '서울특별시', tab: false },

        { region: '인천광역시', tab: false },
        { region: '대전광역시', tab: false },
        { region: '부산광역시', tab: false },
        { region: '대구광역시', tab: false },
        { region: '울산광역시', tab: false },
        { region: '광주광역시', tab: false },
        { region: '세종특별시', tab: false }
      ],
      siteInfo: {},
      essMaster: {},
      weatherRes: {},
      siteAreaList: {},
      siteSearchData: {},
      siteSearchDistins: {},
      siteSearchClickList: {}
    }
  },
  created() {
    this.$store.dispatch('SetLoadingDialog', true)
    this.site_id = this.$route.query.site_id
    this.init_data()
    // 관리자 구분 추가 2019-10-07
    const grpAuth = this.$store.state.user.grp_auth || ''
    this.admin =
      !!(grpAuth === 'usergroup001' ||
      grpAuth === 'usergroup002' ||
      grpAuth === 'usergroup004' ||
      grpAuth === 'usergroup008')
    console.log(store)
    // 디바이스 타입 추가
    let type = navigator.userAgent.toLocaleLowerCase()
    this.devideType =
      type.indexOf('android') > -1 || type.indexOf('iphone') > -1
        ? 'MOBILE'
        : 'PC'
  },
  mounted() {
    // this.mobile_checking()
    // this.initData()
  },
  methods: {
    init_data() {
      let getParams = '?site_id=' + this.site_id
      getSiteInfo(getParams).then(res => {
        this.siteInfo = res
      })

      let params = {
        site_id: this.site_id
      }
      getGeneral(params).then(response => {
        this.essData = response
        this.essMaster = response.essMaster[0]

        this.component_key++
      })
      this.startTimer()
    },
    mobile_checking() {
      this.mobile_check = !isMobile()
    },
    initData() {
      getSiteList({}).then(res => {
        this.siteList = res.siteList
        this.siteAreaList = this.siteList.filter(d => d.AREA === '경기도')
      })

      const grpAuth = this.$store.state.user.grp_auth || ''
      if (grpAuth === 'usergroup001' || grpAuth === 'usergroup002') {
        this.searchArea = true
      }

      this.startTimer()
    },
    getDatas() {
      let params = {
        site_id: this.site_id
      }
      getGeneral(params).then(response => {
        this.essData = response
        this.essMaster = response.essMaster[0]
      })
    },
    getSiteSearch() {
      if ($('#searchWord').val() == '') {
        alert('검색어를 입력해 주세요.')
        return
      }
      let params = {
        search_type: $('#searchType').val(),
        search_word: $('#searchWord').val(),
      }
      // let params = '?' + $('#searchType').val() + '=' + $('#searchWord').val()
      // usergroup_id는 서버 세션에서 결정 - 클라이언트에서 전송하지 않음
      getSiteSearchList(params).then(response => {
        this.siteSearchData = response.SiteSearchList
        this.siteSearchDistins = response.SiteSearchDistincList
      })
    },
    getSiteSearchClick(index, site_id) {
      $('.accordian_area .accordian_box .accordian_over').removeClass('on')
      $("div[name='info_" + site_id + "']").addClass('on')
    },
    changeRegionTab(idx, area) {
      for (var i = 0; i < this.regionTab.length; i++) {
        this.regionTab[i].tab = false
      }
      this.regionTab[idx].tab = true

      this.siteAreaList = this.siteList.filter(d => d.AREA === area)
    },
    changeTab(key) {
      $("span[name='main_tab']").removeClass('on')
      $('#tab_' + key).addClass('on')

      this.component_key++
      this.comp = key
    },
    startTimer() {
      this.stopTimer()
      intervalHandler = setInterval(() => {
        this.getDatas()
      }, 60000 * 2)
    },
    stopTimer() {
      if (intervalHandler) clearInterval(intervalHandler)
      intervalHandler = null
    }
  }
}
</script>

<style lang="less" scoped>
</style>
